import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyClients } from 'api/clients/use-get-many-clients';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params';
import { useClientFiltersStore } from 'shared/stores/use-client-filters.ts';
import { ClientSearch } from 'components/clients/client-search';
import { ClientTable } from 'components/clients/client-table';
import { CreateClient } from 'components/clients/create-client';
import { Pagination } from 'components/pagination';

export const ClientsListPage = () => {
  const { page, limit, handlePageChange } = usePaginationParams();

  const { search } = useClientFiltersStore();

  const { data: clients, isLoading, isPreviousData } = useGetManyClients({ page, limit, search });

  usePageReset([search]);

  const header = <PageHeader title={<ClientSearch />} extra={[<CreateClient />]} />;

  return (
    <DefaultPageLayout header={header}>
      {!isLoading || isPreviousData ? (
        <ClientTable clients={clients?.data || []} isLoading={isPreviousData} />
      ) : (
        <Skeleton />
      )}
      <Pagination total={clients?.pagination?.total} page={page} limit={limit} onChange={handlePageChange} />
    </DefaultPageLayout>
  );
};
